<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
      <!-- Header -->
      <div class="modal-header">
        <h2>User Detail</h2>
        <button class="close-btn" @click="$emit('close')">✕</button>
      </div>

      <!-- Content -->
      <div class="modal-body" v-if="user">
        <!-- Avatar + Basic -->
        <div class="user-header">
          <img v-if="user.avatar" :src="getAvatarUrl(user.avatar)" class="avatar" />
          <div v-else class="avatar-placeholder">
            {{ getInitials(user.name) }}
          </div>
          <div>
            <h3>{{ user.name }}</h3>
            <p class="username">@{{ user.username }}</p>
            <span class="role">{{ user.role }}</span>
          </div>
        </div>

        <!-- Info Grid -->
        <div class="info-grid">
          <div class="info-item">
            <label>Email</label>
            <span>{{ user.email }}</span>
          </div>

          <div class="info-item">
            <label>Phone</label>
            <span>{{ user.phone || "-" }}</span>
          </div>

          <div class="info-item">
            <label>Status</label>
            <span :class="['badge', user.status]">
              {{ user.status }}
            </span>
          </div>

          <div class="info-item">
            <label>Last Login</label>
            <span>{{ formatDate(user.last_login_at) }}</span>
          </div>

          <div class="info-item">
            <label>Login IP</label>
            <span>{{ user.last_login_ip || "-" }}</span>
          </div>

          <div class="info-item">
            <label>Created At</label>
            <span>{{ formatDate(user.created_at) }}</span>
          </div>

          <div class="info-item">
            <label>Updated At</label>
            <span>{{ formatDate(user.updated_at) }}</span>
          </div>
        </div>

        <!-- Permissions -->
        <div class="permissions">
          <label>Permissions</label>
          <div v-if="user.permissions.length">
            <div
              v-for="(group, groupName) in groupPermission(user.permissions)"
              :key="group"
              class="permission-group"
              :class="'group-'+groupName"
            >
              <p class="group-title">{{ groupName }}</p>

              <!-- <span
              v-for="(p, index) in user.permissions"
              :key="index"
              class="tag"
            >
              {{ p.display_name }}
            </span> -->
              <span v-for="p in group" :key="p.id" class="tag">
                {{ p.display_name }}
              </span>
            </div>
          </div>
          <span v-else class="empty">No permissions</span>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button class="btn" @click="$emit('close')">Close</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getAvatarUrl } from "@/utils/helpers";
import { toRefs } from "vue";

const props = defineProps({
  user: Object,
});
const { user } = toRefs(props);

const getInitials = (name) => {
  if (!name) return "";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .substring(0, 2);
};

const groupPermission = (permissions) => {
  return permissions.reduce((acc,p) => {
    if(!acc[p.group]) acc[p.group] = []
    acc[p.group].push(p)
    return acc
  }, {})
};

const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleString();
};
</script>

<style scoped>
/* .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  width: 45%;
  height: 90vh;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.modal-body {
  padding: 20px;
  overflow-y:auto ;
  flex: 1;
}

.user-header {
  display: flex;
  gap: 15px;
  align-items: center;
  margin-bottom: 20px;
}

.avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.username {
  color: gray;
}

.role {
  font-size: 12px;
  color: #666;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.info-item label {
  font-size: 12px;
  color: #888;
}

.info-item span {
  display: block;
  font-weight: 500;
}

.badge.active {
  color: green;
}

.badge.inactive {
  color: red;
}

.permissions {
  margin-top: 20px;
}

.tag {
  background: #eee;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 5px;
}

.empty {
  color: #aaa;
}

.modal-footer {
  padding: 15px;
  text-align: right;
  border-top: 1px solid #eee;
}

.close-btn {
  border: none;
  background: none;
  cursor: pointer;
}

.btn {
  padding: 8px 15px;
  border: none;
  background: #333;
  color: #fff;
  border-radius: 5px;
} */
.avatar-placeholder {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-size: 1.875rem;
  font-weight: 600;
  color: white;
}
.permissions {
  margin-top: 16px;
}

.permission-group {
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
}

.group-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  text-transform: capitalize;
}

/* Tag permissions */
.tag {
  display: inline-block;
  padding: 4px 10px;
  margin: 4px 6px 0 0;
  font-size: 12px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
  border: 1px solid #bae6fd;
  transition: all 0.2s ease;
}

.tag:hover {
  background: #bae6fd;
  transform: translateY(-1px);
}
.group-customers {
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.group-products {
  background: #eef2ff;
  border-color: #c7d2fe;
}

.group-orders {
  background: #fff7ed;
  border-color: #fed7aa;
}

.modal-body::-webkit-scrollbar {
  width: 6px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
